import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PaymentFailedAlertProps {
  subscriptionStatus: string;
  nextPaymentAttempt?: number | null;
}

export const PaymentFailedAlert: React.FC<PaymentFailedAlertProps> = ({
  subscriptionStatus,
  nextPaymentAttempt,
}) => {
  if (subscriptionStatus !== 'past_due') {
    return null;
  }

  const formatDate = (timestamp: number | null | undefined): string => {
    if (!timestamp) return '';
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return (
    <div className="bg-gradient-to-r from-red-500 to-orange-500 shadow-lg">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-3 md:py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
          <div className="flex items-start sm:items-center gap-2 sm:gap-3 flex-1 w-full sm:w-auto">
            <AlertTriangle className="h-5 w-5 sm:h-6 sm:w-6 text-white flex-shrink-0 mt-0.5 sm:mt-0" />
            <div className="text-white flex-1 min-w-0">
              <p className="font-bold text-sm sm:text-base">Payment Failed</p>
              <p className="text-xs sm:text-sm text-white/90 break-words">
                Your last payment was unsuccessful. Please update your payment method to avoid service interruption.
                {nextPaymentAttempt && ` Next retry: ${formatDate(nextPaymentAttempt)}`}
              </p>
            </div>
          </div>
          
          <div className="w-full sm:w-auto">
            <Link
              to="/subscriptions"
              className="block sm:inline-block text-center bg-white text-red-600 px-4 sm:px-5 py-2 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-100 transition-colors shadow-sm whitespace-nowrap w-full sm:w-auto"
            >
              Update Payment
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
